import script from "./ThankYouView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYouView.vue?vue&type=script&setup=true&lang=js"

import "./ThankYouView.vue?vue&type=style&index=0&id=d68bcb7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d68bcb7e"]])

export default __exports__